/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiResult,
    NewDeviceFaultTicketPreview,
    TicketStatusCount,
    TicketSummary,
} from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    NewDeviceFaultTicketPreviewFromJSON,
    NewDeviceFaultTicketPreviewToJSON,
    TicketStatusCountFromJSON,
    TicketStatusCountToJSON,
    TicketSummaryFromJSON,
    TicketSummaryToJSON,
} from "../models/index";

export interface GetNewDeviceFaultTicketPreviewRequest {
    deviceIdentity: string;
}

export interface TicketCreateRedirectRequest {
    deviceIdentity?: string;
}

export interface TicketDetailsRequest {
    ticketId: string;
}

export interface TicketListRequest {
    organisationId?: string;
    openOnly?: boolean;
    deviceIdentity?: string;
    reportedByMe?: boolean;
    updatedSince?: string;
    serviceModelDeviceGroupTag?: string;
    scheduledMaintenanceDeviceGroupTag?: string;
}

export interface TicketStatusCountsRequest {
    organisationId?: string;
    serviceModelDeviceGroupTag?: string;
}

/**
 *
 */
export class TicketingHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Get a preview of a new device fault ticket.
     */
    async getNewDeviceFaultTicketPreviewRaw(
        requestParameters: GetNewDeviceFaultTicketPreviewRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<NewDeviceFaultTicketPreview>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getNewDeviceFaultTicketPreview().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["deviceIdentity"] != null) {
            queryParameters["deviceIdentity"] =
                requestParameters["deviceIdentity"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/tickets/device-fault/preview`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            NewDeviceFaultTicketPreviewFromJSON(jsonValue),
        );
    }

    /**
     * Get a preview of a new device fault ticket.
     */
    async getNewDeviceFaultTicketPreview(
        requestParameters: GetNewDeviceFaultTicketPreviewRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<NewDeviceFaultTicketPreview> {
        const response = await this.getNewDeviceFaultTicketPreviewRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get a redirect url to raise a maintenance ticket, either for the provided device, or omit for a basic prefill for user\'s org only
     */
    async ticketCreateRedirectRaw(
        requestParameters: TicketCreateRedirectRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        if (requestParameters["deviceIdentity"] != null) {
            queryParameters["deviceIdentity"] =
                requestParameters["deviceIdentity"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/tickets/create-redirect`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Get a redirect url to raise a maintenance ticket, either for the provided device, or omit for a basic prefill for user\'s org only
     */
    async ticketCreateRedirect(
        requestParameters: TicketCreateRedirectRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.ticketCreateRedirectRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get ticket details
     */
    async ticketDetailsRaw(
        requestParameters: TicketDetailsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<TicketSummary>> {
        if (requestParameters["ticketId"] == null) {
            throw new runtime.RequiredError(
                "ticketId",
                'Required parameter "ticketId" was null or undefined when calling ticketDetails().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/tickets/{ticketId}`.replace(
                    `{${"ticketId"}}`,
                    encodeURIComponent(String(requestParameters["ticketId"])),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            TicketSummaryFromJSON(jsonValue),
        );
    }

    /**
     * Get ticket details
     */
    async ticketDetails(
        requestParameters: TicketDetailsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<TicketSummary> {
        const response = await this.ticketDetailsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * List tickets raised by user\'s organisation (currently using Jira Service Desk MNT project).
     */
    async ticketListRaw(
        requestParameters: TicketListRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<TicketSummary>>> {
        const queryParameters: any = {};

        if (requestParameters["organisationId"] != null) {
            queryParameters["organisationId"] =
                requestParameters["organisationId"];
        }

        if (requestParameters["openOnly"] != null) {
            queryParameters["openOnly"] = requestParameters["openOnly"];
        }

        if (requestParameters["deviceIdentity"] != null) {
            queryParameters["deviceIdentity"] =
                requestParameters["deviceIdentity"];
        }

        if (requestParameters["reportedByMe"] != null) {
            queryParameters["reportedByMe"] = requestParameters["reportedByMe"];
        }

        if (requestParameters["updatedSince"] != null) {
            queryParameters["updatedSince"] = requestParameters["updatedSince"];
        }

        if (requestParameters["serviceModelDeviceGroupTag"] != null) {
            queryParameters["serviceModelDeviceGroupTag"] =
                requestParameters["serviceModelDeviceGroupTag"];
        }

        if (requestParameters["scheduledMaintenanceDeviceGroupTag"] != null) {
            queryParameters["scheduledMaintenanceDeviceGroupTag"] =
                requestParameters["scheduledMaintenanceDeviceGroupTag"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/tickets`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(TicketSummaryFromJSON),
        );
    }

    /**
     * List tickets raised by user\'s organisation (currently using Jira Service Desk MNT project).
     */
    async ticketList(
        requestParameters: TicketListRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<TicketSummary>> {
        const response = await this.ticketListRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get ticket counts grouped by status (open + closed in last 30 days).
     */
    async ticketStatusCountsRaw(
        requestParameters: TicketStatusCountsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<TicketStatusCount>>> {
        const queryParameters: any = {};

        if (requestParameters["organisationId"] != null) {
            queryParameters["organisationId"] =
                requestParameters["organisationId"];
        }

        if (requestParameters["serviceModelDeviceGroupTag"] != null) {
            queryParameters["serviceModelDeviceGroupTag"] =
                requestParameters["serviceModelDeviceGroupTag"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/tickets/counts/status`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(TicketStatusCountFromJSON),
        );
    }

    /**
     * Get ticket counts grouped by status (open + closed in last 30 days).
     */
    async ticketStatusCounts(
        requestParameters: TicketStatusCountsRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<TicketStatusCount>> {
        const response = await this.ticketStatusCountsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
